<div class="pIndex-con">
    <ul class="pIndex-nav">
        <li class="active">全部语聊</li>
        <li>拨打记录</li>
        <li>接听记录</li>
    </ul>
    <div class="pIndex-content">
        <div class="pIndex-content-item active" id="allDetail"></div>
        <div class="pIndex-content-item" id="dialDetail"></div>
        <div class="pIndex-content-item" id="answerDetail"></div>
    </div>
</div>